import { ButtonGroup, Card, Icon, Modal, Switcher, Tooltip } from 'pepsico-ds'
import React, { useCallback, useEffect, useState, useRef } from 'react'
import { formatNumberWithCommas, returnHyphenIfNull, splitValueWithUnit, handleDomToImgDownloadPdf } from '../../utils/utils'
import ModalFilters from './ModalFilters'
import { Col, Row } from 'antd'
import CustomBarChart from '../Charts/CustomBarChart'
import CommonTable from '../Table/CommonTable'
import { compassDataMock } from "../../mocks/compassData";
import NoData from '../NoData/NoData'
import InfoIcon from '../Icons/InfoIcon'
import { useDispatch, useSelector } from 'react-redux'
import { localStoreKeys } from '../../constants/localStoreKeys'
import CompassStackedChart from '../Charts/CompassChart/CompassStackedChart'
import LegendList from '../Charts/Legend/LegendList'
import { appConstants } from '../../constants/appconstants'
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils'
import CustomButtons from '../Cards/CustomButtons'
import domtoimage from "dom-to-image";
import jsPDF from "jspdf";
import DropdownWithIcons from './DropdownWithIcons'
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';
import { SkeletonList } from '../Skeleton/SkeletonList';
import { PHKPICard } from '../Cards/PHKPICard'



const cellDataFunction = (ctx) => {
    const colId = ctx.column.id
    const percentage = ctx.row.original[colId]
    // console.log("ctx.row.original['commodities']", ctx.row.original);

    if (ctx.row.original['commodities'] === 'Total' || percentage === "-") {
        return (
            <div style={{ width: '100%' }}>{percentage}</div>
        )
    }
    return <div style={{ width: '100%', background: `linear-gradient(to right, #99D5ED ${percentage}, transparent ${percentage})` }}>{percentage}</div>
}


const cellDataFunctionCoverage = (ctx) => {
    const colId = ctx.column.id
    return <div>{formatNumberWithCommas(ctx.row.original[colId])}</div>
}

let columns = [
    { columnKey: 'commodities', header: "Category", columnAlignment:'center', cellData: cellDataFunction },
    {
        columnKey: 'fySpend', header: () => <span style={{ display: "flex" }}><span style={{ marginRight: "5px" }}>Covered Spend</span>
            <InfoIcon text="Blank Covered Price indicate that the CMs are yet to update the prices" />
        </span>
        , cellData: cellDataFunction
    },
    { columnKey: 'spendData', header: "Spend %", columnAlignment:'center', cellData: cellDataFunction },
    { columnKey: 'q1VolCov', header: "Q1 Vol. Coverage", columnAlignment:'center', cellData: cellDataFunction },
    { columnKey: 'q2VolCov', header: "Q2 Vol. Coverage", columnAlignment:'center', cellData: cellDataFunction },
    { columnKey: 'q3VolCov', header: "Q3 Vol. Coverage", columnAlignment:'center', cellData: cellDataFunction },
    { columnKey: 'q4VolCov', header: "Q4 Vol. Coverage", columnAlignment:'center', cellData: cellDataFunction },
    { columnKey: 'fyVolCov', header: "FY Vol. Coverage", columnAlignment:'center', cellData: cellDataFunction },
];

let coverageColumns = [
    // { columnKey: 'a', header: '' },
    { columnKey: 'sector', header: "Sector", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'bu', header: "BU", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'country', header: "Country", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'l0', header: "Category L0", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'l1', header: "Category L1", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'l2', header: "Category L2", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'year', header: "Year", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'forecastValue', header: "Forecast Volume", cellData: cellDataFunctionCoverage, size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'coverageVolume', header: "Covered Volume", cellData: cellDataFunctionCoverage, size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'unit', header: "Unit of Measure", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'coveredPrice', header: "Covered Price ($ MN)", cellData: cellDataFunctionCoverage, size: 90, minSize: 90, maxSize: 140 },
];

const tableData1 = [
    { commodity: 'Aluminum', fySpend: '$917.9M', spend: '15.56%', q1Vol: '66.9%', q2Vol: '59.6%', q3Vol: '47.5%', q4Vol: '100%', fyVol: '58.0%' },
    { commodity: 'Corn', fySpend: '$917.9M', spend: '25.56%', q1Vol: '66.9%', q2Vol: '59.6%', q3Vol: '47.5%', q4Vol: '57.2%', fyVol: '58.0%' },
    { commodity: 'Cornmeal', fySpend: '$917.9M', spend: '5.56%', q1Vol: '66.9%', q2Vol: '59.6%', q3Vol: '47.5%', q4Vol: '57.2%', fyVol: '58.0%' },
    { commodity: 'Total', fySpend: '$917.9M', spend: '5.56%', q1Vol: '66.9%', q2Vol: '59.6%', q3Vol: '47.5%', q4Vol: '57.2%', fyVol: '58.0%' },
]

function CompassModal({ openModal, setOpenModal, userData,  userDataV2, selectedYear, capability, userDataLandingPage, landingPageFilters }) {
    // Track modal view when opened
    const MODAL_TITLE = 'Commodity Buy Plan';
    const dispatch = useDispatch();
    useEffect(() => {
        if (openModal) {
            try {
                trackModalView(`${MODAL_TITLE} ${capability}`, 'view');
            } catch (error) {
                // Silent fail for tracking errors to not disrupt user experience
            }
        }
    }, [openModal, capability]);

    
    const handleClose = () => {
        try {
            trackModalView(`${MODAL_TITLE} ${capability}`, 'close');
        } catch (error) {
            // Silent fail for tracking errors
        }
        dispatch({ 
            type: 'RESET_COMPASS_DROPDOWN_ACTION', 
            payload: "RESET_COMPASS_DROPDOWN_ACTION" 
        });
        dispatch({ 
            type: 'RESET_COMPASS_DROPDOWN_V2_ACTION', 
            payload: "RESET_COMPASS_DROPDOWN_V2_ACTION" 
        });
        dispatch({ 
            type: 'RESET_COMPASS_KPI_PAGE_HEADER_ACTION', 
            payload: "RESET_COMPASS_KPI_PAGE_HEADER_ACTION" 
        });
        dispatch({ 
            type: 'RESET_COMPASS_SECTOR_BU_CHART_ACTION', 
            payload: "RESET_COMPASS_SECTOR_BU_CHART_ACTION" 
        });
        dispatch({ 
            type: 'RESET_COMPASS_SECTOR_CATEGORY_CHART_ACTION', 
            payload: "RESET_COMPASS_SECTOR_CATEGORY_CHART_ACTION" 
        });
        dispatch({ 
            type: 'RESET_COMPASS_COVERAGE_REPORT_CHART_ACTION', 
            payload: "RESET_COMPASS_COVERAGE_REPORT_CHART_ACTION" 
        });
        dispatch({ 
            type: 'RESET_COMPASS_EXECUTIVE_SUMMARY_ACTION', 
            payload: "RESET_COMPASS_EXECUTIVE_SUMMARY_ACTION" 
        });
        setOpenModal(false);

        // setCompassKpiPageHeaderData({});
        // setCompassSectorBuChartData({});
        // setCompassSectorCategoryChartData({});
        // setCompassCoverageReportChartData({});
        // setCompassExecutiveSummaryData({});

    };
    
    const [loader, setLoader] = useState(true)
    const [compassData, setCompassData] = useState({})
    const [compassKpiPageHeaderData, setCompassKpiPageHeaderData] = useState({})
    const [compassSectorBuChartData, setCompassSectorBuChartData] = useState({})
    const [compassSectorCategoryChartData, setCompassSectorCategoryChartData] = useState({})
    const [compassCoverageReportChartData, setCompassCoverageReportChartData] = useState({})
    const [compassExecutiveSummaryData, setCompassExecutiveSummaryData] = useState({})
    const [tableData, setTableData] = useState([])
    const [countrySwitcherIndex, setcountrySwitcherIndex] = useState(0)
    const [compassFilterSnapshots, setCompassFilterSnapshots] = useState({})
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const [fromDateDisplayValue, setFromDateDisplayValue] = useState([])
    // console.log(fromDateDisplayValue)
    //const [fromDateDisplayValue?.[0], fromDateDisplayValue?.[1]] = fromDateDisplayValue?.split(" ")
    const tableHeader = "Executive Summary for the Covered 'Buy Plan' for the Year " + fromDateDisplayValue?.[1]
    const infoIconText = fromDateDisplayValue ? "Data displayed is as per the " + fromDateDisplayValue?.[0] + " " + fromDateDisplayValue?.[1] + " snapshot" : ""
    // console.log("compassData", compassData);

    const saveCompassFilterSnapshot = useCallback((mode, snapshot) => {
        setCompassFilterSnapshots(current => ({ ...current, [mode]: snapshot }));
    }, []);

    useEffect(() => {
        if (!openModal) {
            setCompassFilterSnapshots({});
        }
    }, [openModal]);

    const kpiPageHeaderdata = useSelector((state) => state.getCompassKpiPageHeaderReducer); 
    const sectorBuChartKpiData = useSelector((state) => state.getCompassSectorBuChartReducer); 
    const sectorCategoryChartKpiData = useSelector((state) => state.getCompassSectorCategoryChartReducer); 
    const coverageReportKpiData = useSelector((state) => state.getCompassCoverageReportChartReducer); 
    const executiveSummaryKpiData = useSelector((state) => state.getCompassExecutiveSummaryReducer); 

    const iskpiPageHeaderdataLoading = kpiPageHeaderdata?.loading;
    const issectorBuChartKpiDataLoading = sectorBuChartKpiData?.loading;
    const issectorCategoryChartKpiDataLoading = sectorCategoryChartKpiData?.loading;
    const isCoverageReportKpiDataLoading = coverageReportKpiData?.loading;
    const isExecutiveSummaryKpiDataLoading = executiveSummaryKpiData?.loading;

    const dropdownFilterIsLoading = useSelector((state) => state.getCompassDropdownReducer?.loading);
    const dropdownV2FilterIsLoading = useSelector((state) => state.getCompassDropdownV2Reducer?.loading);

    const isHeaderKpiLoading = !!iskpiPageHeaderdataLoading;
    const isSectorBUKpiLoading = !!issectorBuChartKpiDataLoading;
    const isSectorCategoryKpiLoading = !!issectorCategoryChartKpiDataLoading;
    const isExecutiveSummaryLoading = !!isExecutiveSummaryKpiDataLoading;
    const isCoverageReportLoading = !!isCoverageReportKpiDataLoading;

    const isDropdownFilterLoading = !!dropdownFilterIsLoading;
    const isDropdownV2FilterLoading = !!dropdownV2FilterIsLoading;

    const sectorSelectedData = JSON.parse(localStorage.getItem('sectorSelected') || '[]')
    const spendByChartTitle1 = sectorSelectedData?.length === 1 && countrySwitcherIndex == 1
        ? "Covered Spend by BU and Country"
        : "Covered Spend by Sector and BU"

    const spendByChartTitle2 = sectorSelectedData?.length === 1 && countrySwitcherIndex == 1
        ? "Covered Spend by BU and Category"
        : "Covered Spend by Sector and Category"

    
    useEffect(() => {

        let appList = [];
        // if(value?.data?.type==="SUCCESS_COMPASS_DETAIL_VIEW_ACTION") {
            
        //     setCompassData(value.data);
        //     appList = value.data?.apps
        // }
        if(kpiPageHeaderdata && kpiPageHeaderdata?.type==="SUCCESS_COMPASS_KPI_PAGE_HEADER_ACTION") {
            
            setCompassKpiPageHeaderData(kpiPageHeaderdata);
            appList = kpiPageHeaderdata?.apps
        }
        if(sectorBuChartKpiData && sectorBuChartKpiData?.type==="SUCCESS_COMPASS_SECTOR_BU_CHART_ACTION") {
            
            setCompassSectorBuChartData(sectorBuChartKpiData);
            // appList = sectorBuChartKpiData?.apps
        }
        if(sectorCategoryChartKpiData && sectorCategoryChartKpiData?.type==="SUCCESS_COMPASS_SECTOR_CATEGORY_CHART_ACTION") {
            
            setCompassSectorCategoryChartData(sectorCategoryChartKpiData);
            // appList = sectorCategoryChartKpiData?.apps
        }
        if(coverageReportKpiData && coverageReportKpiData?.type==="SUCCESS_COMPASS_COVERAGE_REPORT_CHART_ACTION") {
            
            setCompassCoverageReportChartData(coverageReportKpiData);
            // appList = coverageReportKpiData?.apps
        }
        if(executiveSummaryKpiData && executiveSummaryKpiData?.type==="SUCCESS_COMPASS_EXECUTIVE_SUMMARY_ACTION") {
            
            setCompassExecutiveSummaryData(executiveSummaryKpiData);
            // appList = executiveSummaryKpiData?.apps
        }
        // console.log(value);
        // setLoader(value.loader)
        // if (value.modalName == "Compass" && appList && appList.length > 0) {
        //     const tempbuttonGroupItems = appList
        //         ?.filter(item => item.isActive)
        //         .map(item => ({
        //             label: item.app,
        //             onClick: () => window.open(item.url, "_blank"),
        //         }));

        //     setButtonGroupItems(tempbuttonGroupItems)
        // }
        let fromdateselected = localStorage.getItem("fromDateSelected")
        const parsedFromDateSelected = JSON.parse(fromdateselected)
        const fromDateDisplayText = JSON.stringify(parsedFromDateSelected?.[0]?.displayText) || ""

        setFromDateDisplayValue(fromDateDisplayText?.split(" "))
            
    }, [kpiPageHeaderdata, sectorBuChartKpiData, sectorCategoryChartKpiData, coverageReportKpiData, executiveSummaryKpiData])
    
    useEffect(() => {
        setCompassKpiPageHeaderData({});
        setCompassSectorBuChartData({});
        setCompassSectorCategoryChartData({});
        setCompassCoverageReportChartData({});
        setCompassExecutiveSummaryData({});
    },[countrySwitcherIndex])

    
        useEffect(() => {
            return () => {
                dispatch({ 
                    type: 'RESET_COMPASS_DROPDOWN_ACTION', 
                    payload: "RESET_COMPASS_DROPDOWN_ACTION" 
                });
                dispatch({ 
                    type: 'RESET_COMPASS_DROPDOWN_V2_ACTION', 
                    payload: "RESET_COMPASS_DROPDOWN_V2_ACTION" 
                });
                dispatch({ 
                    type: 'RESET_COMPASS_KPI_PAGE_HEADER_ACTION', 
                    payload: "RESET_COMPASS_KPI_PAGE_HEADER_ACTION" 
                });
                dispatch({ 
                    type: 'RESET_COMPASS_SECTOR_BU_CHART_ACTION', 
                    payload: "RESET_COMPASS_SECTOR_BU_CHART_ACTION" 
                });
                dispatch({ 
                    type: 'RESET_COMPASS_SECTOR_CATEGORY_CHART_ACTION', 
                    payload: "RESET_COMPASS_SECTOR_CATEGORY_CHART_ACTION" 
                });
                dispatch({ 
                    type: 'RESET_COMPASS_COVERAGE_REPORT_CHART_ACTION', 
                    payload: "RESET_COMPASS_COVERAGE_REPORT_CHART_ACTION" 
                });
                dispatch({ 
                    type: 'RESET_COMPASS_EXECUTIVE_SUMMARY_ACTION', 
                    payload: "RESET_COMPASS_EXECUTIVE_SUMMARY_ACTION" 
                });
            };
        }, []);

    
    useEffect(() => {
        const executiveSummary = compassExecutiveSummaryData?.data?.executiveSummary?.[0]?.executiveSummaryData.slice()
        const totalCount = compassExecutiveSummaryData?.data?.executiveSummary?.[0]?.total
        const formatteTotalCountdData = totalCount && Object.fromEntries(
            Object.entries(totalCount).map(([key, value]) =>
                typeof value === "number" ? [key, `${value.toFixed(1)}%`] : [key, value]
            )
        );
        if (executiveSummary) {
            executiveSummary?.push(totalCount)
            let tempTableData = executiveSummary?.map(item => ({
                ...item,
                fySpend: item.fySpend ? `${item.fySpend}` : '-',
                spendData: item.spendData ? `${item.spendData}%` : '-',
                q1VolCov: item.q1VolCov ? `${item.q1VolCov}%` : '-',
                q2VolCov: item.q2VolCov ? `${item.q2VolCov}%` : '-',
                q3VolCov: item.q3VolCov ? `${item.q3VolCov}%` : '-',
                q4VolCov: item.q4VolCov ? `${item.q4VolCov}%` : '-',
                fyVolCov: item.fyVolCov ? `${item.fyVolCov}%` : '-'
            }));
            setTableData(tempTableData)
        }
    }, [compassExecutiveSummaryData])


    const actualSpendValue = splitValueWithUnit(compassKpiPageHeaderData?.data?.headerData?.currentYearActualSpend)
    const lastYearActualSpendData = compassKpiPageHeaderData?.data?.headerData?.lastYearActualSpend
    const actualSpendPercent = compassKpiPageHeaderData?.data?.headerData?.actualSpendPercent
    console.log(lastYearActualSpendData);

    const plannedSpendValue = splitValueWithUnit(compassKpiPageHeaderData?.data?.headerData?.currentYearPlannedSpend)
    const lastYearSpendData = compassKpiPageHeaderData?.data?.headerData?.lastYearPlannedSpend
    const percentOfLastYearData = compassKpiPageHeaderData?.data?.headerData?.plannedSpendPercent

    // const averageCoveredPrice = splitValueWithUnit(compassKpiPageHeaderData?.data?.headerData?.currentYearAverageCoveredPrice)
    // const lastYearAveragePrice = compassKpiPageHeaderData?.data?.headerData?.lastYearAverageCoveredPrice
    // const percentOfAveragePrice = compassKpiPageHeaderData?.data?.headerData?.averageCoveredPricePercent

    const volumeCoverage = compassKpiPageHeaderData?.data?.headerData?.fyVolume
    const weightedCoverage = compassKpiPageHeaderData?.data?.headerData?.weightCoverage
    const activePlaybooks = compassKpiPageHeaderData?.data?.headerData?.activePlayBookCount
    const activeBuyPlans = compassKpiPageHeaderData?.data?.headerData?.activeBuyPlanCount
    const betweenVsPriorYear = splitValueWithUnit(compassKpiPageHeaderData?.data?.headerData?.selectedVsPriorYear)
    const avgCoveredPrice = splitValueWithUnit(compassKpiPageHeaderData?.data?.headerData?.averageCoveredPrice)
    const coverageReportTableData = compassCoverageReportChartData?.data?.coverageReportData || []
    const categoriesWithColorForBU = compassSectorBuChartData?.data?.buColorMapping
    const stackedBarDetailsForBU = compassSectorBuChartData?.data?.compassSectorBuData
    const categoriesWithColorForCategory = compassSectorCategoryChartData?.data?.categoryColorMapping
    const stackedBarDetailsForCategory = compassSectorCategoryChartData?.data?.compassSectorCategoryData
    const isEDFIntegrated = compassData?.data?.edfintegrated;

    const executivecolumnsToInclude = ["CATEGORY", "COVERED SPEND", "SPEND %", "Q1 VOL. COVERAGE", "Q2 VOL. COVERAGE", "Q3 VOL. COVERAGE", "Q4 VOL. COVERAGE", "FY VOL. COVERAGE"]

    const executivecolumnMapping = {
        "commodities": "CATEGORY",
        "fySpend": "COVERED SPEND",
        "spendData": "SPEND %",
        "q1VolCov": "Q1 VOL. COVERAGE",
        "q2VolCov": "Q2 VOL. COVERAGE",
        "q3VolCov": "Q3 VOL. COVERAGE",
        "q4VolCov": "Q4 VOL. COVERAGE",
        "fyVolCov": "FY VOL. COVERAGE"
      }
      

    const coveragecolumnsToInclude = ["SECTOR", "BU", "COUNTRY", "CATEGORY L0", "CATEGORY L1", "CATEGORY L2", "YEAR", "FORECAST VOLUME", "COVERED VOLUME", "UNIT OF MEASURE", "COVERED PRICE ($ MN)"]

    const coveragecolumnMapping = {
        "sector": "SECTOR",
        "bu": "BU",
        "country": "COUNTRY",
        "l0": "CATEGORY L0",
        "l1": "CATEGORY L1",
        "l2": "CATEGORY L2",
        "year": "YEAR",
        "forecastValue": "FORECAST VOLUME",
        "coverageVolume": "COVERED VOLUME",
        "unit": "UNIT OF MEASURE",
        "coveredPrice": "COVERED PRICE ($ MN)"
      }

    const filteredCoverageColumns = countrySwitcherIndex === 1
        ? coverageColumns
        : coverageColumns.filter((column) => column.columnKey !== 'country')

    const filteredCoverageColumnsToInclude = countrySwitcherIndex === 1
        ? coveragecolumnsToInclude
        : coveragecolumnsToInclude.filter((column) => column !== 'COUNTRY')

      const compassModalRef = useRef();
      const spendSectorBURef = useRef();
      const spendSectorCategoryRef = useRef();

        const { showToast } = useToast();


        
        const checkPDFDownloaded = () => {}
    
      
    
    return (
        <Modal
            onCloseModal={handleClose}
            primaryButtonProps={{
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${MODAL_TITLE} ${capability}`)}
        >
            {/* <div>              */}
                {/* <button onClick={() => handleDomToImgDownloadPdf("compassModalRef")}>PDF</button> */}
            <div ref={compassModalRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{width: '100%'}}>
                        {userData.FirstName}, the Covered 'Buy Plan' for your category is <b>{formatNumberWithCommas(actualSpendValue['numericValue']) || 0}{actualSpendValue['unit']}</b>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>                
                    <>
                        {/* <ButtonGroup
                            style={{ marginRight: '2rem' }}
                            className="buy-con-button-group"
                            items={buttonGroupItems}
                            size="small"
                        /> */}
                        <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <CustomButtons isModal={true} appList={compassKpiPageHeaderData?.data?.apps} />
                            {/* <button onClick={() => handleDomToImgDownloadPdf(compassModalRef, "Compass_Modal")}>PDF</button> */}
                            <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={compassModalRef} kpiName={"Compass_Modal"} isModal={true}/>
                            </span>
                        </span>
                    </>
                </div>
                {(compassKpiPageHeaderData?.data?.lastUpdate) && <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(compassKpiPageHeaderData?.data?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(compassKpiPageHeaderData?.data?.refreshFrequency)}</div>}
                <div className='buy-con-dropdown-label' 
                    style={{fontFamily: "Inter", fontSize: "0.75rem", fontWeight: "500", marginBottom: '3px'}}>View by</div>
                <div style={{width: '25%', marginBottom: '1rem'}}>
                    <Switcher
                        className=""
                        items={[
                            {
                            label: 'Sector BU',
                            leadingIcon: 'edit',
                            showLeadingIcon: false,
                            style: {width: '50%', display: 'flex', justifyContent: 'center'}
                            },
                            {
                            label: 'Sector BU Country',
                            leadingIcon: 'edit',
                            showLeadingIcon: false,
                            style: {width: '50%', display: 'flex', justifyContent: 'center'}
                            }
                        ]}
                        selectedItemIndex={countrySwitcherIndex}
                        onUpdate= {(val) => {
                            setcountrySwitcherIndex(val)
                        }}
                        style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}
                    />
                </div>
                
                <ModalFilters modalName={"Compass"} selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} userDataV2={userDataV2} landingPageFilters={landingPageFilters} setLoader={setLoader} countrySwitcherIndex={countrySwitcherIndex} isModalOpen={openModal} compassFilterSnapshot={compassFilterSnapshots[countrySwitcherIndex]} onCompassFilterSnapshotChange={saveCompassFilterSnapshot} />
                
                {
                    fromDateDisplayValue ?
                        <div className="modal-update-frequesncy" style={{ display: "flex", marginBottom: "0px", fontSize: "12px" }}><Icon alt="" icon="info" size="small" /> &nbsp; {infoIconText}</div>
                        : ""
                }
                {
                        <>
                            {/* <div className='spend-modal-total-spend-text' style={{ display: "flex", flexDirection: "row-reverse", marginRight: "3rem", fontWeight: 700 }}>Monthly Buy Plan Metrics - {fromDateDisplayValue?.[0]}-{fromDateDisplayValue?.[1]}</div> */}
                            <br />
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            {
                                (isHeaderKpiLoading || isDropdownFilterLoading || isDropdownV2FilterLoading) ? (
                                    <PHKPICard
                                        slotContent={<SkeletonList count={3} height={26} />}
                                        className={"vr-card"}
                                    />
                                ) : (
                            <Card style={{ height: '100%',display:'flex' }}>
                                <div className='header-kpi-wrapper'>
                                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                    <>
                                        <div className="spend-modal-alphanumeric-value">
                                            <div className='spend-modal-numeric-value'>{formatNumberWithCommas(plannedSpendValue['numericValue']) || 0}</div>
                                            <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{plannedSpendValue['unit']} </div>
                                        </div>
                                        <div className='spend-modal-total-spend-text' style={{ display: "flex" }}>Yearly Committed 'Buy Plan' &nbsp;<InfoIcon text="Committed 'Buy Plan' is equivalent to Forecasted 'Buy Plan'" /></div>
                                    </>
                                </Col>
                                <Col xs={24} sm={24} md={2} lg={2} xl={2}>
                                    <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column', justifyContent: 'flex-start', height: '100%' }}>
                                        {
                                            lastYearSpendData !== undefined || lastYearSpendData !== null ?
                                                <>
                                                    <div className="spend-modal-last-year-value">
                                                        <span className="last-year">LY</span>
                                                        <span className="last-year-value">
                                                            {formatNumberWithCommas(lastYearSpendData) || 'N/A'}
                                                        </span>
                                                    </div>
                                                </> : ''
                                        }
                                        {
                                            percentOfLastYearData ?
                                                <>
                                                    <div className="spend-modal-percentage-value">
                                                        <span>
                                                            {percentOfLastYearData}%
                                                        </span>
                                                        <Icon
                                                            alt="alt value"
                                                            icon={parseFloat(percentOfLastYearData) == 0 ? "" : (parseFloat(percentOfLastYearData) > 0 ? "arrow_upward" : "arrow_downward")}
                                                            size="small"
                                                            style={{ color: '#fff', fontSize: 13 }}
                                                        />
                                                    </div>
                                                </> : ''
                                        }
                                    </div>
                                </Col>
                                {
                                    actualSpendValue !== undefined && actualSpendValue !== null ?
                                        <>
                                            <div className="compass-modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                <div>
                                                    <div className="spend-modal-alphanumeric-value-small">
                                                        <div className='spend-modal-numeric-value-small'>{actualSpendValue ? formatNumberWithCommas(actualSpendValue?.['numericValue']) : 0}</div>
                                                        <div className="spend-modal-alpha-value-small">{actualSpendValue?.['unit']}</div>
                                                    </div>
                                                    <div className='spend-modal-manage-spend' style={{ display: "flex" }}>Yearly Covered 'Buy Plan' &nbsp;<InfoIcon text="Covered 'Buy Plan' is equivalent to Booked/Contracted 'Buy Plan'" /></div>
                                                </div>
                                            </Col>
                                        </> : ''
                                }
                                <Col xs={24} sm={24} md={2} lg={2} xl={2}>
                                    <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column', justifyContent: 'flex-start', height: '100%' }}>
                                        {
                                            lastYearActualSpendData !== undefined || lastYearActualSpendData !== null ?
                                                <>
                                                    <div className="spend-modal-last-year-value">
                                                        <span className="last-year">LY</span>
                                                        <span className="last-year-value">
                                                            {formatNumberWithCommas(lastYearActualSpendData) || 'N/A'}
                                                        </span>
                                                    </div>
                                                </> : ''
                                        }
                                        {
                                            actualSpendPercent ?
                                                <>
                                                    <div className="spend-modal-percentage-value">
                                                        <span>
                                                            {actualSpendPercent}%
                                                        </span>
                                                        <Icon
                                                            alt="alt value"
                                                            icon={parseFloat(actualSpendPercent) == 0 ? "" : (parseFloat(actualSpendPercent) > 0 ? "arrow_upward" : "arrow_downward")}
                                                            size="small"
                                                            style={{ color: '#fff', fontSize: 13 }}
                                                        />
                                                    </div>
                                                </> : ''
                                        }
                                    </div>
                                </Col>
                                {
                                    volumeCoverage !== null || volumeCoverage !== undefined ?
                                        <>
                                            <div className="compass-modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                <div>
                                                    <div className="spend-modal-total-supplier">{volumeCoverage || 0}%<InfoIcon style={{ position: 'absolute', top: -10 }} text="Covered 'Buy Plan' Volume/Committed 'Buy Plan' Volume" /></div>
                                                    <div className='spend-modal-manage-spend'>Yearly Volume Coverage</div>
                                                </div>
                                            </Col>
                                        </> : ''
                                }
                                
                                
                                
                                </div>
                            </Card>
                                )
                            }
                            </Col>    
                            </Row>
                            <br />
                            <Row gutter={[10, 10]} style={{ width: '100%' }}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={spendSectorBURef} style={{ height: '100%'}}>
                                        {
                                            (isSectorBUKpiLoading || isDropdownFilterLoading || isDropdownV2FilterLoading) ? (
                                               <PHKPICard 
                                                    slotContent={<SkeletonList count={8} height="30"/>}
                                                    className={"vr-card"}
                                                />
                                                
                                            ) : (
                                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                    <div className="archlet-chart-title">{spendByChartTitle1} {appConstants.inUSDMillion}
                                                    <span style={{float: 'right'}}>
                                                        <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={spendSectorBURef} kpiName={`${spendByChartTitle1} (in USD Million)`}/>
                                                    </span>
                                                    </div>
                                                    {
                                                        stackedBarDetailsForBU && stackedBarDetailsForBU.length > 0 ?
                                                            <><CompassStackedChart categories={categoriesWithColorForBU} data={stackedBarDetailsForBU} YAxisLabel={"Covered Spend ($ MN)"} />
                                                                <LegendList legends={categoriesWithColorForBU} /></>
                                                            : <NoData />
                                                    }
                                                </Card>
                                            )
                                        }
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{backgroundColor: '#fff'}}>
                                    <div ref={spendSectorCategoryRef}>
                                        {
                                            (isSectorCategoryKpiLoading || isDropdownFilterLoading || isDropdownV2FilterLoading) ? (
                                                <PHKPICard
                                                    slotContent={<SkeletonList count={8} height="30" />}
                                                    className={"vr-card"}
                                                />
                                            ) : (
                                                <Card style={{ height: '100%' }}>
                                                    <div className="archlet-chart-title">{spendByChartTitle2} {appConstants.inUSDMillion}
                                                        <span style={{float: 'right'}}>
                                                            <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={spendSectorCategoryRef} kpiName={`${spendByChartTitle2} (in USD Million)`}/>
                                                        </span>
                                                    </div>
                                                    {
                                                        stackedBarDetailsForCategory && stackedBarDetailsForCategory.length > 0 ?
                                                            <>
                                                            <CompassStackedChart categories={categoriesWithColorForCategory} data={stackedBarDetailsForCategory} YAxisLabel={"Covered Spend ($ MN)"} />
                                                                <LegendList legends={categoriesWithColorForCategory} />
                                                            </>
                                                            : <NoData />
                                                    }
                                                </Card>
                                            )
                                        }
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    {/* <div ref={compassExecutiveSummaryRef}>   */}
                                        {
                                            (isExecutiveSummaryLoading || isDropdownFilterLoading || isDropdownV2FilterLoading) ? (
                                                <PHKPICard
                                                    slotContent={<SkeletonList count={8} height="30" />}
                                                    className={"vr-card"}
                                                />
                                            ) : compassExecutiveSummaryData?.data?.executiveSummary?.[0]?.executiveSummaryData && compassExecutiveSummaryData?.data?.executiveSummary?.[0]?.executiveSummaryData.length > 0 ?
                                                <div className="ph-table-wrapper">
                                                    <CommonTable className="compass-table" data={tableData} columns={columns} tableHeader={tableHeader} columnsToInclude={executivecolumnsToInclude} columnMapping={executivecolumnMapping} tableName={tableHeader.toUpperCase()}/>
                                                </div>
                                                : <Card><div style={{ width: '100%', textAlign: 'left', fontSize: 18, fontWeight: 700, color: '#3a3a3a' }}>{tableHeader}</div><NoData /></Card>
                                        }
                                    {/* </div> */}
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    {/* <Card> */}
                                    {
                                        (isCoverageReportLoading || isDropdownFilterLoading || isDropdownV2FilterLoading) ? (
                                            <PHKPICard
                                                slotContent={<SkeletonList count={8} height="30" />}
                                                className={"vr-card"}
                                            />
                                        ) : coverageReportTableData && coverageReportTableData.length > 0 ?
                                            <div className="ph-table-wrapper">
                                                <CommonTable className="compass-category-table" data={coverageReportTableData} columns={filteredCoverageColumns} tableHeader={"Coverage Report for 3 years"} enableSorting={true} columnsToInclude={filteredCoverageColumnsToInclude} columnMapping={coveragecolumnMapping} tableName={'COVERAGE REPORT FOR 3 YEARS'}/>
                                            </div>
                                            : <Card><div style={{ width: '100%', textAlign: 'left', fontSize: 18, fontWeight: 700, color: '#3a3a3a' }}>Coverage Report for 3 years</div><NoData /></Card>
                                    }
                                    {/* </Card> */}
                                </Col>
                            </Row>
                            <br />

                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                {
                                    compassKpiPageHeaderData?.data?.owners?.length > 0 &&
                                    <div style={{width: '100%'}}>Please reach out to {compassKpiPageHeaderData?.data?.owners?.map((contact, index) => (
                                        <React.Fragment key={index}>
                                            <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                            {index < compassKpiPageHeaderData?.data?.owners?.length - 1 && ', '}
                                        </React.Fragment>
                                    ))} for any query on the data displayed.</div>
                                }
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                        </>
                }
                <br/>
            </div>
            {/* </div> */}
        </Modal >
    )
}

export default CompassModal